import React, { useState, useEffect } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import es from "date-fns/locale/es";
import "./stylesCotizadorPlazo.scss";

export const CotizadorProgrammaticPlazo = ({ onPlazoChange, defaultPlazo, plazo, resetCounter }) => {
  const today = new Date();
  const thirtyDaysLater = new Date(today);
  thirtyDaysLater.setDate(today.getDate() + 30);

  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [numberOfDays, setNumberOfDays] = useState(defaultPlazo || 0);
  const [useExactDays, setUseExactDays] = useState(defaultPlazo && ![5, 10, 20].includes(defaultPlazo) ? true : false);
  const [useExactDates, setUseExactDates] = useState(false);
  const [useOneWeek, setUseOneWeek] = useState(defaultPlazo === 5);
  const [useTwoWeeks, setUseTwoWeeks] = useState(defaultPlazo === 10);
  const [useOneMonth, setUseOneMonth] = useState(defaultPlazo === 20);
  const [lastResetCounter, setLastResetCounter] = useState(0);

  // Sincronizar con la prop plazo y resetear cuando cambie resetCounter
  useEffect(() => {
    // Solo reseteamos los estados si resetCounter ha cambiado
    if (resetCounter !== lastResetCounter) {
      setNumberOfDays(plazo || 0);
      setUseOneWeek(plazo === 5);
      setUseTwoWeeks(plazo === 10);
      setUseOneMonth(plazo === 20);
      setUseExactDays(plazo && ![5, 10, 20].includes(plazo) ? true : false);
      setUseExactDates(false);
      setStartDate(null);
      setEndDate(null);
      setLastResetCounter(resetCounter);
    }
  }, [resetCounter, lastResetCounter, plazo]);

  useEffect(() => {
    if (defaultPlazo) {
      setNumberOfDays(defaultPlazo);
      onPlazoChange(defaultPlazo);
    }
  }, [defaultPlazo, onPlazoChange]);

  const handleStartDateChange = (date) => {
    setStartDate(date);
    updateNumberOfDays(date, endDate);
  };

  const handleEndDateChange = (date) => {
    setEndDate(date);
    updateNumberOfDays(startDate, date);
  };

  const isWeekday = (date) => {
    const day = date.getDay();
    return day !== 0 && day !== 6;
  };

  const updateNumberOfDays = (start, end) => {
    if (start && end) {
      const startDate = new Date(start);
      const endDate = new Date(end);
      let days = 0;

      if (isWeekday(startDate)) {
        days++;
      }
      if (isWeekday(endDate)) {
        days++;
      }

      const currentDate = new Date(start);
      currentDate.setDate(currentDate.getDate() + 1);

      while (currentDate < endDate) {
        if (isWeekday(currentDate)) {
          days++;
        }
        currentDate.setDate(currentDate.getDate() + 1);
      }

      setNumberOfDays(days);
      onPlazoChange(days);
    } else {
      setNumberOfDays(0);
      onPlazoChange(0);
    }
  };

  const handleOneWeekChange = () => {
    const newValue = !useOneWeek;
    setUseOneWeek(newValue);
    setUseTwoWeeks(false);
    setUseOneMonth(false);
    setUseExactDays(false);
    setUseExactDates(false);
    setStartDate(null);
    setEndDate(null);
    const days = newValue ? 5 : 0;
    setNumberOfDays(days);
    onPlazoChange(days);
  };

  const handleTwoWeeksChange = () => {
    const newValue = !useTwoWeeks;
    setUseOneWeek(false);
    setUseTwoWeeks(newValue);
    setUseOneMonth(false);
    setUseExactDays(false);
    setUseExactDates(false);
    setStartDate(null);
    setEndDate(null);
    const days = newValue ? 10 : 0;
    setNumberOfDays(days);
    onPlazoChange(days);
  };

  const handleOneMonthChange = () => {
    const newValue = !useOneMonth;
    setUseOneWeek(false);
    setUseTwoWeeks(false);
    setUseOneMonth(newValue);
    setUseExactDays(false);
    setUseExactDates(false);
    setStartDate(null);
    setEndDate(null);
    const days = newValue ? 20 : 0;
    setNumberOfDays(days);
    onPlazoChange(days);
  };

  const handleDropdownChange = (event) => {
    const selectedDays = parseInt(event.target.value, 10);
    setNumberOfDays(selectedDays);
    onPlazoChange(selectedDays);
    setUseExactDays(true);
  };

  const handleExactDaysChange = () => {
    const newValue = !useExactDays;
    setUseOneWeek(false);
    setUseTwoWeeks(false);
    setUseOneMonth(false);
    setUseExactDays(newValue);
    setUseExactDates(false);
    setStartDate(null);
    setEndDate(null);
    if (!newValue) {
      setNumberOfDays(0);
      onPlazoChange(0);
    }
  };

  const handleExactDatesChange = () => {
    const newValue = !useExactDates;
    setUseOneWeek(false);
    setUseTwoWeeks(false);
    setUseOneMonth(false);
    setUseExactDays(false);
    setUseExactDates(newValue);
    setStartDate(null);
    setEndDate(null);
    setNumberOfDays(0);
    onPlazoChange(0);
  };

  const startOf2024 = new Date(2024, 0, 1);
  const endOf2030 = new Date(2030, 11, 31);

  return (
    <div className="plazo">
      <p className="tituloplazo">PLAZO</p>
      <hr />
      <div className="seleccion">
        <label>
          <input type="checkbox" className="cb123" checked={useOneMonth} onChange={handleOneMonthChange} />
          1 MES
          <br />
        </label>
      </div>
      <div className="seleccion">
        <label>
          <input type="checkbox" className="cb123" checked={useOneWeek} onChange={handleOneWeekChange} />
          1 SEMANA
          <br />
        </label>
      </div>
      <div className="seleccion">
        <label>
          <input type="checkbox" className="cb123" checked={useTwoWeeks} onChange={handleTwoWeeksChange} />
          2 SEMANAS
          <br />
        </label>
      </div>
      <div className="seleccion">
        <label>
          <input type="checkbox" className="cb123" checked={useExactDays} onChange={handleExactDaysChange} />
          CANTIDAD
          <br />
        </label>
      </div>
      <div className="seleccion">
        <label>
          <input type="checkbox" className="cb123" checked={useExactDates} onChange={handleExactDatesChange} />
          CALENDARIO
        </label>
      </div>
      <hr />
      {useExactDates && (
        <div>
          <div>
            <label style={{ marginTop: "1rem", marginBottom: "1rem", fontSize: "20px" }}>INICIO</label>
            <div>
              <DatePicker
                selected={startDate}
                onChange={handleStartDateChange}
                locale={es}
                dateFormat="dd/MM/yyyy"
                placeholderText={today.toLocaleDateString("es-ES", {
                  day: "2-digit",
                  month: "2-digit",
                  year: "numeric",
                })}
                wrapperClassName="datePickerWrapper"
                minDate={startOf2024}
                maxDate={endOf2030}
              />
            </div>
            <label style={{ marginTop: "1rem", marginBottom: "1rem", fontSize: "20px" }}>FIN</label>
            <div>
              <DatePicker
                selected={endDate}
                onChange={handleEndDateChange}
                locale={es}
                dateFormat="dd/MM/yyyy"
                placeholderText={thirtyDaysLater.toLocaleDateString("es-ES", {
                  day: "2-digit",
                  month: "2-digit",
                  year: "numeric",
                })}
                wrapperClassName="datePickerWrapper"
                minDate={startOf2024}
                maxDate={endOf2030}
              />
            </div>
          </div>
          <p className="bajadaplazo">
            SE CONTABILIZAN LA CANTDIDAD DE DÍAS COMPRENDIDOS ENTRE LUNES Y VIERNES (SÁBADOS Y DOMINGOS SE DESCARTAN)
          </p>
        </div>
      )}
      {useExactDays && (
        <div className="dropdown-coti-plazo">
          <select value={numberOfDays} onChange={handleDropdownChange} className="dropdown-select">
            {[...Array(261).keys()].map((day) => (
              <option key={day} value={day}>
                {day}
              </option>
            ))}
          </select>
          <div className="bajadaplazo">
            EXHIBICIÓN DE LUNES A VIERNES <br /> SEMANA = 5 DÍAS
          </div>
        </div>
      )}
    </div>
  );
};
